import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { QueryBaseSchema } from '@pkg/api/query/QueryFilterSchema'
import { defineEntityConfig } from '@pkg/db/schema/EntityConfig'
import { ButtonLink } from '@pkg/ui/button'
import { LinkIndicatorIcon } from '@pkg/ui/common'
import { FormattedNameAndAddress } from '@pkg/ui/formattedContent/NameAndAddress'
import { FaBriefcaseMedical } from 'react-icons/fa6'
import { z } from 'zod'
import { CostCarrierEditDrawer } from './edits/CostCarrierEditDrawer'
import { CostCarrierSchema } from './schema/CostCarrier'

const label = t`Kostenträger`
export const CostCarrierConfig = defineEntityConfig(() => ({
  schema: CostCarrierSchema,

  label,
  labelPlural: t`Kostenträger`,

  icon: FaBriefcaseMedical,

  route: {
    list: '/kostentrager',
    edit: '/kostentrager/$id',
    new: '/kostentrager/new',
  },
  drawer: { modal: CostCarrierEditDrawer },

  indexColumns: [
    {
      key: 'costCarrier.name',
      title: label,
      sorter: true,
      fixed: 'start',
      render: (_, row) => (
        <FormattedNameAndAddress
          name={row.name}
          address={row.address ?? undefined}
          link={{ to: '/kostentrager/$id', params: { id: row.id } }}
        />
      ),
    },
    {
      title: t`IK-Nummer`,
      key: 'ikNumber',
      render: (_, record) => record.ikNumber?.main?.ikNumber,
    },
    {
      key: 'actions',
      title: <Trans>Aktionen</Trans>,
      sorter: false,
      fixed: 'end',
      render: (_, row) => (
        <ButtonLink to="/kostentrager/$id" params={{ id: row.id }} size="small" shape="round">
          <Trans>Anzeigen</Trans>
          <LinkIndicatorIcon />
        </ButtonLink>
      ),
    },
  ],

  relationSelectionColumns: [
    {
      key: 'costCarrier.name',
      title: label,
      sorter: true,
      render: (_, row) => <FormattedNameAndAddress name={row.name} address={row.address ?? undefined} />,
    },
  ],

  search: {
    filterSchema: QueryBaseSchema.extend({
      sortBy: z
        .enum([
          'costCarrier.name',
          'costCarrier.address.streetAddress',
          'costCarrier.address.zipCode',
          'costCarrier.address.city',
        ])
        .nullish(),
    }),
    sortableFields: ['name', 'createdAt'] as const,
    defaultSortBy: 'name',
    defaultSortOrder: 'asc',
  },

  format: {
    primary: val => val?.name,
  },
}))
